import { render } from "./AddRecord.vue?vue&type=template&id=7f9da132&scoped=true"
import script from "./AddRecord.vue?vue&type=script&lang=js"
export * from "./AddRecord.vue?vue&type=script&lang=js"

import "@/components/modal-responsive.css?vue&type=style&index=0&id=7f9da132&scoped=true&lang=css&external"
import "./AddRecord.vue?vue&type=style&index=1&id=7f9da132&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f9da132"]])

export default __exports__